import { takeEvery, put, select } from 'redux-saga/effects';

import restaurantOrdersActions from '../actionTypes/restaurantOrdersActions';
import { API_CALL } from '../actionTypes/sharedActions';
import {
  GET_COMPANY_WISE_RESTAURANT_ORDERS,
  UPDATE_COMPANY_ORDER_STATUS,
  GET_RESTAURANT_ORDER,
} from '../routes';
import {
  GET_RESTURANT_ORDER_DETAILS_SUCCESS,
  GET_RESTURANT_ORDER_DETAILS_FAILED,
} from '../actionTypes';

const getRestaurantId = (state) => state.currentRestaurant.id;

function* getRestaurantOrders({ payload }) {
  const id = yield select(getRestaurantId);
  yield put({
    type: API_CALL,
    payload: {
      url: GET_COMPANY_WISE_RESTAURANT_ORDERS.replace(':id', id),
      method: 'GET',
      data: payload,
    },
    successAction: restaurantOrdersActions.getRestaurantOrdersSuccess,
    failureAction: restaurantOrdersActions.getRestaurantOrdersFailed,
  });
}

function* getRestaurantOrderDetails({ payload }) {
  const id = yield select(getRestaurantId);
  yield put({
    type: API_CALL,
    payload: {
      url: GET_RESTAURANT_ORDER.replace(':id', id),
      method: 'GET',
      data: payload,
    },
    successAction: GET_RESTURANT_ORDER_DETAILS_SUCCESS,
    failureAction: GET_RESTURANT_ORDER_DETAILS_FAILED,
  });
}

function* updateCompanyOrderStatus({ payload }) {
  const { id, status } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_COMPANY_ORDER_STATUS.replace(':id', id).replace(
        ':status',
        status.toLowerCase(),
      ),
      method: 'POST',
      data: payload,
    },
    successAction: restaurantOrdersActions.updateCompanyOrderStatusSuccess,
    failureAction: restaurantOrdersActions.updateCompanyOrderStatusFailed,
  });
}

export default function* watchRestaurantOrders() {
  yield takeEvery(
    restaurantOrdersActions.getRestaurantOrders,
    getRestaurantOrders,
  );
  yield takeEvery(
    restaurantOrdersActions.updateCompanyOrderStatus,
    updateCompanyOrderStatus,
  );

  // yield takeEvery(
  //   restaurantOrdersActions.updateCompanyOrderStatusSuccess,
  //   getRestaurantOrders
  // );

  yield takeEvery(
    restaurantOrdersActions.updateCompanyOrderStatusSuccess,
    getRestaurantOrderDetails,
  );
}
